<template>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-button class="button_back" data-testid="directions-100" @click="goBack()">
                <ion-icon name="arrow-back-outline"></ion-icon>
            </ion-button>
        </ion-buttons>
        <ion-title>Job Details</ion-title>

    </ion-toolbar>
    <div class="main_wrapper ion-padding">
        <div class="container">
            <!-- <div class="card-header">
                <div class="job-info">
                    <div class="image_wrapper" data-testid="directions-323"
                        @click="userApplicationsInfoModalOpen(job.jobPost.pharmacy)">
                        <el-avatar :size="'small'" shape="square" :src="job.jobPost.pharmacy.image"
                            v-if="job.jobPost.pharmacy.image" />
                        <el-avatar :size="'small'" class="avatar-job" shape="square"
                            icon="locumate_icons locumate_icon-user1 locumate_icons-avatar" v-else></el-avatar>
                    </div>
                    <div class="job-detail">
                        <div class="job-title">{{ job.jobPost.title }}</div>
                        <div class="job-poster">{{ job.jobPost.pharmacy.name }}</div>
                    </div>
                </div>
                <div class="job-type-label-container">
                    <div class="job-type-label" :class="getClass(job.status)" v-if="job.status != ''">{{ job.status }}</div>
                    <div class="job-type-label">{{ job.jobPost.type }}</div>
                </div>
            </div>
            <div class="info-list">
                <ul>
                    <li>
                        <img src="@/assets/img/job-seeker/location.svg" height="20" alt="" />
                        <span>{{ job.jobPost.location }}</span>
                    </li>
                    <li>
                        <img src="@/assets/img/job-seeker/hospital.svg" height="20" alt="" />
                        <span>{{ job.jobPost.category }}</span>
                    </li>
                    <li>
                        <img src="@/assets/img/job-seeker/date-inactive.svg" height="20" alt="" />
                        <span>Applied {{ job.appliedAgo }}</span>
                    </li>
                </ul>
            </div>
            <div class="card-content">

                <div v-html="job.jobPost.description">
                </div>

            </div> -->
        
            <div class="job-detail-header">
                <div class="image_wrapper" data-testid="directions-64" @click="userInfoModalOpen(job.jobPharmacy)">
                    <el-avatar :size="'small'" shape="square" :src="job.jobPost.pharmacy.image"
                        v-if="job.jobPost.pharmacy.image" />
                    <el-avatar :size="'small'" class="avatar-job" shape="square"
                        icon="locumate_icons locumate_icon-user1 locumate_icons-avatar" v-else></el-avatar>
                </div>
                <div class="job-detail-header-row">
                    <div class="job-detail-header-row-left">
                        <div class="job-title">{{ job.jobPost.title }}</div>
                        <div class="job-poster">{{ job.jobPost.pharmacy.name }}</div>
                    </div>
                    <el-tag class="inverted job-application-status" :class="getClass(job.status)">
                        {{ job.status }}
                    </el-tag>
                </div>
                <div class="job-extra-info">
                    <el-tag class="inverted">
                        Published {{ job.jobPost.publishedDate }}
                    </el-tag>
                </div>
                

                <div class="preview-section">
                    <div class="preview-section__header">
                        <div class="preview-section__title">
                            Job Details
                        </div>
                    </div>
                    <p v-html="displayedText" class="job-description"></p>
                    <el-button class="text-only" @click="toggleView"  v-if="isShowMoreJD"> 
                        {{ state.isTruncated ? 'View More' : 'View Less' }}
                    </el-button>
                </div>

                <div class="separator"></div>
                <div class="preview-section">
                    <!-- <div class="detail-item"> -->
                    <!--     <div class="detail-item__icon"> -->
                    <!--         <svg width="14" height="18" viewBox="0 0 14 18" fill="none" -->
                    <!--             xmlns="http://www.w3.org/2000/svg"> -->
                    <!--             <path -->
                    <!--                 d="M13 5.25V12.75C13 15.75 12.25 16.5 9.25 16.5H4.75C1.75 16.5 1 15.75 1 12.75V5.25C1 2.25 1.75 1.5 4.75 1.5H9.25C12.25 1.5 13 2.25 13 5.25Z" -->
                    <!--                 stroke="rgb(var(--locumate-primary-color-dark))" stroke-width="1.5" -->
                    <!--                 stroke-linecap="round" stroke-linejoin="round" /> -->
                    <!--             <path d="M8.5 4.125H5.5" stroke="rgb(var(--locumate-primary-color-dark))" -->
                    <!--                 stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /> -->
                    <!--             <path -->
                    <!--                 d="M6.9999 14.325C7.64193 14.325 8.1624 13.8045 8.1624 13.1625C8.1624 12.5205 7.64193 12 6.9999 12C6.35787 12 5.8374 12.5205 5.8374 13.1625C5.8374 13.8045 6.35787 14.325 6.9999 14.325Z" -->
                    <!--                 stroke="rgb(var(--locumate-primary-color-dark))" stroke-width="1.5" -->
                    <!--                 stroke-linecap="round" stroke-linejoin="round" /> -->
                    <!--         </svg> -->
                    <!--     </div> -->
                    <!--     <div class="detail-item__value">4-5 Yrs Experience (static)</div> -->
                    <!-- </div> -->
                    <div class="detail-item">
                        <div class="detail-item__icon">
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M18.3332 9.99984C18.3332 14.5998 14.5998 18.3332 9.99984 18.3332C5.39984 18.3332 1.6665 14.5998 1.6665 9.99984C1.6665 5.39984 5.39984 1.6665 9.99984 1.6665C14.5998 1.6665 18.3332 5.39984 18.3332 9.99984Z"
                                    stroke="rgb(var(--locumate-primary-color-dark))" stroke-width="1.5"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path
                                    d="M13.0919 12.65L10.5086 11.1083C10.0586 10.8416 9.69189 10.2 9.69189 9.67497V6.2583"
                                    stroke="rgb(var(--locumate-primary-color-dark))" stroke-width="1.5"
                                    stroke-linecap="round" stroke-linejoin="round" />
                            </svg>

                        </div>
                        <div class="detail-item__value">{{ job.jobPost.type }}</div>
                    </div>
                    <div class="detail-item" v-if="!job.jobPost.hideSalary">
                        <div class="detail-item__icon">
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M7.22656 11.9417C7.22656 13.0167 8.05156 13.8834 9.07656 13.8834H11.1682C12.0599 13.8834 12.7849 13.125 12.7849 12.1917C12.7849 11.175 12.3432 10.8167 11.6849 10.5834L8.32656 9.4167C7.66823 9.18337 7.22656 8.82503 7.22656 7.80837C7.22656 6.87503 7.95156 6.1167 8.84323 6.1167H10.9349C11.9599 6.1167 12.7849 6.98337 12.7849 8.05837"
                                    stroke="rgb(var(--locumate-primary-color-dark))" stroke-width="1.5"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M10 5V15" stroke="rgb(var(--locumate-primary-color-dark))" stroke-width="1.5"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path
                                    d="M9.99984 18.3332C14.6022 18.3332 18.3332 14.6022 18.3332 9.99984C18.3332 5.39746 14.6022 1.6665 9.99984 1.6665C5.39746 1.6665 1.6665 5.39746 1.6665 9.99984C1.6665 14.6022 5.39746 18.3332 9.99984 18.3332Z"
                                    stroke="rgb(var(--locumate-primary-color-dark))" stroke-width="1.5"
                                    stroke-linecap="round" stroke-linejoin="round" />
                            </svg>


                        </div>
                        <div class="detail-item__value">{{ job.jobPost.payInterval }} Rate: {{ job.jobPost.payRate }}
                        </div>
                    </div>
                    <div class="detail-item">
                        <div class="detail-item__icon">
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M9.9999 11.1917C11.4358 11.1917 12.5999 10.0276 12.5999 8.5917C12.5999 7.15576 11.4358 5.9917 9.9999 5.9917C8.56396 5.9917 7.3999 7.15576 7.3999 8.5917C7.3999 10.0276 8.56396 11.1917 9.9999 11.1917Z"
                                    stroke="rgb(var(--locumate-primary-color-dark))" stroke-width="1.5" />
                                <path
                                    d="M3.01675 7.07484C4.65842 -0.141827 15.3501 -0.133494 16.9834 7.08317C17.9418 11.3165 15.3084 14.8998 13.0001 17.1165C11.3251 18.7332 8.67508 18.7332 6.99175 17.1165C4.69175 14.8998 2.05842 11.3082 3.01675 7.07484Z"
                                    stroke="rgb(var(--locumate-primary-color-dark))" stroke-width="1.5" />
                            </svg>

                        </div>
                        <div class="detail-item__value">{{ job.jobPost.location }}</div>
                    </div>
                </div>

                <div class="separator" v-if="job.jobPost.selectedJobPostSkills.length > 0"></div>
                <div class="preview-section" v-if="job.jobPost.selectedJobPostSkills.length > 0">
                    <div class="preview-section__header">
                        <div class="preview-section__title">
                            Skills
                        </div>
                    </div>

                     <div class="skill-list-pills">
                        <div v-for="skill in job.jobPost.selectedJobPostSkills" :key="skill.id">
                            <el-tag class="inverted pill">{{ skill.name }}</el-tag>
                        </div>
                    </div>
                </div>

                <div class="separator"></div>
                <div class="preview-section">
                    <div class="preview-section__header">
                        <div class="preview-section__title">
                            Other Details
                        </div>
                    </div>

                    <div v-if="job.jobPost.pharmacy.scripts" class="job-scripts">
                        <div class="detail-item" v-for="(item, key) in job.jobPost.pharmacy.scripts" :key="key">
                            <div class="detail-item__icon">
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path d="M6.6665 10.1665H12.4998" stroke="rgb(var(--locumate-primary-color-dark))"
                                        stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path d="M6.6665 13.5H10.3165" stroke="rgb(var(--locumate-primary-color-dark))"
                                        stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path
                                        d="M8.33317 4.99984H11.6665C13.3332 4.99984 13.3332 4.1665 13.3332 3.33317C13.3332 1.6665 12.4998 1.6665 11.6665 1.6665H8.33317C7.49984 1.6665 6.6665 1.6665 6.6665 3.33317C6.6665 4.99984 7.49984 4.99984 8.33317 4.99984Z"
                                        stroke="rgb(var(--locumate-primary-color-dark))" stroke-width="1.5"
                                        stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                    <path
                                        d="M13.3333 3.3501C16.1083 3.5001 17.5 4.5251 17.5 8.33343V13.3334C17.5 16.6668 16.6667 18.3334 12.5 18.3334H7.5C3.33333 18.3334 2.5 16.6668 2.5 13.3334V8.33343C2.5 4.53343 3.89167 3.5001 6.66667 3.3501"
                                        stroke="rgb(var(--locumate-primary-color-dark))" stroke-width="1.5"
                                        stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>

                            </div>
                            <div class="detail-item__content">
                                <div class="detail-item__topic">
                                    Average script per day {{ key === 'weekdays' ? '(' + key + ')' : key }}
                                </div>
                                <div class="detail-item__value">{{ item }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="detail-item">
                        <div class="detail-item__icon">
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M6.66685 18.3333H13.3335C16.6835 18.3333 17.2835 16.9917 17.4585 15.3583L18.0835 8.69167C18.3085 6.65833 17.7252 5 14.1668 5H5.83351C2.27518 5 1.69185 6.65833 1.91685 8.69167L2.54185 15.3583C2.71685 16.9917 3.31685 18.3333 6.66685 18.3333Z"
                                    stroke="rgb(var(--locumate-primary-color-dark))" stroke-width="1.5"
                                    stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                <path
                                    d="M6.6665 4.99984V4.33317C6.6665 2.85817 6.6665 1.6665 9.33317 1.6665H10.6665C13.3332 1.6665 13.3332 2.85817 13.3332 4.33317V4.99984"
                                    stroke="rgb(var(--locumate-primary-color-dark))" stroke-width="1.5"
                                    stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                <path
                                    d="M11.6668 10.8333V11.6667C11.6668 11.675 11.6668 11.675 11.6668 11.6833C11.6668 12.5917 11.6585 13.3333 10.0002 13.3333C8.35016 13.3333 8.3335 12.6 8.3335 11.6917V10.8333C8.3335 10 8.3335 10 9.16683 10H10.8335C11.6668 10 11.6668 10 11.6668 10.8333Z"
                                    stroke="rgb(var(--locumate-primary-color-dark))" stroke-width="1.5"
                                    stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M18.0415 9.1665C16.1165 10.5665 13.9165 11.3998 11.6665 11.6832"
                                    stroke="rgb(var(--locumate-primary-color-dark))" stroke-width="1.5"
                                    stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M2.18311 9.3916C4.05811 10.6749 6.17477 11.4499 8.33311 11.6916"
                                    stroke="rgb(var(--locumate-primary-color-dark))" stroke-width="1.5"
                                    stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>

                        </div>
                        <div class="detail-item__content">
                            <div class="detail-item__topic">
                                Dispensing Software
                            </div>
                            <div class="detail-item__value">{{ job.jobPost.pharmacy.software }}</div>
                        </div>
                    </div>
                </div>


                <div v-if="job.jobPost.pharmacy.services">
                    <div class="separator"></div>
                    <div class="preview-section">
                        <div class="preview-section__header">
                            <div class="preview-section__title">
                                Services
                            </div>
                        </div>
                        <div class="detail-item" v-for="(item, key) in job.jobPost.pharmacy.services" :key="key">
                            <div class="detail-item__icon">
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M7.49984 18.3332H12.4998C16.6665 18.3332 18.3332 16.6665 18.3332 12.4998V7.49984C18.3332 3.33317 16.6665 1.6665 12.4998 1.6665H7.49984C3.33317 1.6665 1.6665 3.33317 1.6665 7.49984V12.4998C1.6665 16.6665 3.33317 18.3332 7.49984 18.3332Z"
                                        stroke="rgb(var(--locumate-primary-color-dark))" stroke-width="1.5"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M6.4585 9.99993L8.81683 12.3583L13.5418 7.6416"
                                        stroke="rgb(var(--locumate-primary-color-dark))" stroke-width="1.5"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                </svg>

                            </div>
                            <div class="detail-item__value">{{ item }}</div>
                        </div>
                    </div>
                </div>

            </div>
        </div>


    </div>
    <modal-user-application-info :modalName="'userApplicationInfoModal'"
        :options="userApplicationInfoModal"></modal-user-application-info>
</template>
  
<script>
import {
    useRouter, useRoute
} from "vue-router";
import { onMounted, inject, ref, onBeforeMount, computed, reactive } from 'vue';
import { addIcons } from 'ionicons';
import { arrowBackOutline } from 'ionicons/icons';
addIcons({
    'arrow-back-outline': arrowBackOutline,
});
import { IonToolbar, IonButton, } from '@ionic/vue';
import { PharmacyInfoModal } from "@/modals/modals";
import { useStore } from "vuex";

export default {
    components: {
        IonToolbar,
        IonButton,
        "modal-user-application-info": PharmacyInfoModal,
    },
    setup() {
        const $router = useRouter();
        const $route = useRoute();
        const setPageClassGlobal = inject('setPageClassGlobal');
        const selectedOption = ref(null);
        const $store = useStore();
        const currentRouteName = ref(null);
        const $modals = inject("$modals");
        const state = reactive({
            isTruncated: true
        });
        const job = ref(
            {
                id: 1,
                title: 'Full time Pharmacy Assistant',
                pharmacy: {
                    name: 'Malvern Corner Pharmacy',
                    address: {
                        street: '123 Fake St',
                        city: 'Melbourne',
                        state: 'VIC',
                        postcode: '3000',
                    }
                },
                job_category: 'Pharmacy (Healthcare & Medical)',
                job_type: 'Full Time',
                description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed euismod, diam quis aliquam ultricies, nisl nunc aliquet enim, vitae aliquam nisl nunc vitae nisl. Sed euismod, diam quis aliquam ultricies, nisl nunc aliquet enim, vitae aliquam nisl nunc vitae nisl.',
            }
        );

        const jobId = computed(() => $route.params.jobId);

        const goBack = () => {
            currentRouteName.value = $router.currentRoute.value.name;
            console.log("🚀 ~ await ~ currentRouteName.value:", currentRouteName.value)
            $store.dispatch('PREVIOUS_ROUTE_NAME', currentRouteName.value);
            $router.push({
                name: "job_seeker_previous_applications",
            });

        };

        const getClass = (status) => {
      // Convert the status to lowercase for case-insensitive comparison
      const lowercaseStatus = status.toLowerCase();
      
      // Return class based on status
     return lowercaseStatus;
    };

       

        const toggleView = () => {
            state.isTruncated = !state.isTruncated;
        };

        const displayedText = computed(() => {
            const original = job.value.jobPost.description;
            if (state.isTruncated && original && original.split(' ').length > 50) {
                return original.split(' ').slice(0, 50).join(' ') + '...';
            } else {
                return original;
            }
        });

        const isShowMoreJD = computed(() => {
            const jobDescription = job.value.jobPost.description || '';
            return jobDescription.split(' ').length > 50;
        });

        const handleConfirm = () => {
            // Handle confirmation logic
            console.log('Selected option:', selectedOption.value);
           
        };

        


        onMounted(() => {
            setPageClassGlobal('global_job_poster_page');
        });

        onBeforeMount(async () => {
            try {
                // Dispatch first action
                const jobPostResponse = await $store.dispatch("JOB_SEEKER_APPLICATION_DETAILS_WITHDRAW", {
                    jobId: jobId.value,
                    params: {
                        with: "jobPost,jobPost.pharmacy",
                    },
                });

                job.value = jobPostResponse.data;
                console.log("🚀 ~ onBeforeMount ~ job:", job)

            } catch (error) {
                console.error("Error occurred:", error);
            }
        });

        const userApplicationInfoModal = ref({
            name: "userInfo",
            user: {},
        });
        const userApplicationsInfoModalOpen = (user) => {
            if (user) {
                userApplicationInfoModal.value.user = user;
            }
            $modals.open("userApplicationInfoModal");
        };

        return {
            goBack,
            job,
            jobId,
            getClass,
            handleConfirm,
            userApplicationInfoModal,
            userApplicationsInfoModalOpen,
            displayedText,
            toggleView,
            state,
            isShowMoreJD
        };
    },
};
</script>
  
